export interface AppNotification {
  id: number;
  notificationSubject: string;
  notificationContent: string;
  createdOn: string | null;
  severity: number;
  isRead: boolean;
  timesago: string;
}

/** Maps to the backend NotificationSeverity enum values. */
export const NotificationSeverity = {
  Info: 1,
  Warning: 2,
  Regular: 3,
  Success: 4,
  Error: 5
} as const;
